/**
 * Created by Mark on 18/12/2016.
 */

import ApplicationServices from './base-service.js';
import Constants from '../constants.js';
import Action    from '../application-actions.js';
import React  from 'react';

class  AccountService {

    createMessageClass(title, message, classUid) {
        return ApplicationServices.call(Constants.CREATE_MESSAGE , 
            {title:title, message:message, classUid:classUid});
    }

    createMessageStudent(title, message, studentUid) {
        return ApplicationServices.call(Constants.CREATE_MESSAGE , 
            {title:title, message:message, studentUid:studentUid});
    }

    createMessageAccount(title, message) {
        return ApplicationServices.call(Constants.CREATE_MESSAGE , 
            {title:title, message:message, isAccount:true});
    }

    createMessageAssignment(title, message, assignmentUid) {
        return ApplicationServices.call(Constants.CREATE_MESSAGE , 
            {title:title, message:message, assignmentUid:assignmentUid});
    }

    createMessageStudents(title, message, studentsArray) {
        return ApplicationServices.call(Constants.CREATE_MESSAGE , 
            {title:title, message:message, studentsArray:studentsArray});
    }


    sendEmail(name , email , message){
        return ApplicationServices.call(Constants.SEND_MSG , {name:name , email:email , message:message})
    }

    requestRenew(){
        return ApplicationServices.call(Constants.RQUEST_RENEW , {})
    }

    getMembers(){
        return ApplicationServices.call(Constants.GET_ACCOUNT_STAFF , {}).then(function(response){
            Action.update(Constants.GET_ACCOUNT_STAFF , response.staff);
        });
    }

    editStaff(uid , firstName , lastName , email , classes,title){
        return ApplicationServices.call(Constants.EDIT_ACCOUNT_STAFF , {uid:uid , firstName:firstName,lastName:lastName,email:email,passChanged:'false',classes:classes, title:title}).then(function(response){
            return;
        });
    }

    newPassword(uid){
        return ApplicationServices.call(Constants.EDIT_ACCOUNT_STAFF_PASSWORD , {uid:uid}).then(function(response){
            return response;
        });
    }

    getStudents(){
        return ApplicationServices.call(Constants.GET_ACCOUNT_STUDENTS , {}).then(function(response){
            Action.update(Constants.GET_ACCOUNT_STUDENTS , response.students);
        });
    }

    getInformation(){
        return ApplicationServices.call(Constants.GET_ACCOUNT , {}).then(function(response){
            Action.update(Constants.GET_ACCOUNT , response.account);
            return response.account;
        });
    };

    update(fields){
        return ApplicationServices.call(Constants.UPDATE_ACCOUNT , {fields:fields}).then(function(response){
            return response.done;
        });
    };

    getProductDetails(productUid){
        return ApplicationServices.call(Constants.GET_PRODUCT_FEATURES , {productUid:productUid}).then(function(response){
            Action.update(Constants.GET_PRODUCT_FEATURES , response);
            return response.features;
        });
    };

    getCurriculumDetails(curriculumUid){
        return ApplicationServices.call(Constants.GET_CURRICULUM_DATA , {curriculumUid:curriculumUid}).then(function(response){
            Action.update(Constants.GET_CURRICULUM_DATA , response);
            return response;
        });
    };

    updateAppStore(fields){
        return ApplicationServices.call(Constants.UPDATE_APPSTORE , {fields:fields}).then(function(response){
            Action.update(Constants.UPDATE_APPSTORE , response);
            return response.done;
        });
    };

    getEmojiData(boundThis) {
        var returnEmojiKey = function(emojiData) {
            return <span class="notSelect" onClick={function() {
                if ( this.state.lastSelected == undefined) {
                    return;
                }
                var $txt = this.state.lastSelected;
                var caretPos = $txt.selectionStart;
                if (this.state.lastPosition != undefined) {
                    caretPos = this.state.lastPosition;
                }
                if (this.state.lastSelectType == "title") {
                    var textAreaTxt = this.state.messageTitle;
                    var newTextValue = textAreaTxt.substring(0, caretPos) + emojiData + textAreaTxt.substring(caretPos);
                    this.setState({messageTitle:newTextValue, 
                        lastPosition:caretPos + emojiData.length});
                } else {
                    var textAreaTxt = this.state.messageMessage;
                    var newTextValue = textAreaTxt.substring(0, caretPos) + emojiData + textAreaTxt.substring(caretPos);
                    this.setState({messageMessage:newTextValue, 
                                    lastPosition:caretPos + emojiData.length});
                }
            }.bind(boundThis)} style={{fontSize:"30px"}}>{emojiData}</span>
        }.bind(boundThis);

        var emojiKeys = ['😀','😁','😂','😎','😕','🙃','🤯','😬','😷','⭐️','🔥'];

        var emojiKeysObjects = [];

        for (var i = 0; i < emojiKeys.length; i++) {
            emojiKeysObjects.push(returnEmojiKey(emojiKeys[i]));
        }

        return emojiKeysObjects;
    }
}

export default new AccountService();